<p-toast></p-toast>
<!-- <div #divClick (click)="appMain.toggleMenu($event)"></div> -->
<!-- extra code start -->
<!-- <p-progressBar mode="indeterminate" *ngIf="isChartLoading" class="mb-5"></p-progressBar> -->
<div *ngIf="false" class="container mb-3">
    <div class="main-section">
        <div class="box-section">
            <div class="box box-one">
                <!-- <div class="box-header">
                    <h4>{{ 'FARMER_APPLICATIONS' | translate}} : <span style="color: 'black'">{{ summaryData?.totalApp ? summaryData?.totalApp : 0 }}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'FARMER_APPLICATIONS' | translate}} : <span style="color: 'black'">{{ summaryData?.totalApp ? summaryData?.totalApp : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'VERIFIED'| translate}}</h5>
                            <h3>{{ summaryData?.VerifiedApp ? summaryData?.VerifiedApp : 0 }}</h3>
                        </div>
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.IncompleteApp ? summaryData?.IncompleteApp : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-two">
                <!-- <div class="box-header">
                    <h4>{{ 'PRE_SURVEY' | translate}} : <span style="color: 'black'">{{ summaryData?.total_Preestimate ? summaryData?.total_Preestimate : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'PRE_SURVEY' | translate}} : <span style="color: 'black'">{{ summaryData?.total_Preestimate ? summaryData?.total_Preestimate : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'UPLOADED'| translate}}</h5>
                            <h3>{{ summaryData?.verified_Preestimate ? summaryData?.verified_Preestimate : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.pending_Preestimate ? summaryData?.pending_Preestimate : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-three">
                <!-- <div class="box-header">
                    <h4>{{ 'VENDOR_ESTIMATES' | translate}} : <span style="color: 'black'">{{ summaryData?.totalEstimatedApp ? summaryData?.totalEstimatedApp : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'VENDOR_ESTIMATES' | translate}} : <span style="color: 'black'">{{ summaryData?.totalEstimatedApp ? summaryData?.totalEstimatedApp : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'UPLOADED'| translate}}</h5>
                            <h3>{{ summaryData?.verifiedEstimateApp ? summaryData?.verifiedEstimateApp : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.pendingEstimateApp ? summaryData?.pendingEstimateApp : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-four">
                <!-- <div class="box-header">
                    <h4>{{ 'ESTIMATE_VERIFICATION' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalEstApproved ? summaryData?.TotalEstApproved : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'ESTIMATE_VERIFICATION' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalEstApproved ? summaryData?.TotalEstApproved : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'VERIFIED'| translate}}</h5>
                            <h3>{{ summaryData?.verifiedEstApproved ? summaryData?.verifiedEstApproved : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.pendingEstApproved ? summaryData?.pendingEstApproved : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-five">
                <!-- <div class="box-header">
                    <h4>{{ 'TOTAL_FARMER_CHALLAN' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalChallan_tobe_Generated ? summaryData?.TotalChallan_tobe_Generated : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'TOTAL_FARMER_CHALLAN' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalChallan_tobe_Generated ? summaryData?.TotalChallan_tobe_Generated : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'GENERATED'| translate}}</h5>
                            <h3>{{ summaryData?.ChallanGenerated ? summaryData?.ChallanGenerated : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.PendingChallanGenerated ? summaryData?.PendingChallanGenerated : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-six">
                <!-- <div class="box-header">
                    <h4>{{ 'TOTAL_BILLS_OF_QUANTITY' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalBOQ_tobe_Uploaded ? summaryData?.TotalBOQ_tobe_Uploaded : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'TOTAL_BILLS_OF_QUANTITY' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalBOQ_tobe_Uploaded ? summaryData?.TotalBOQ_tobe_Uploaded : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'UPLOADED'| translate}}</h5>
                            <h3>{{ summaryData?.BOQUploaded ? summaryData?.BOQUploaded : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.BOQPending ? summaryData?.BOQPending : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-seven">
                <!-- <div class="box-header">
                    <h4>{{ 'TOTAL_PHYSICAL_VERIFICATION' | translate}} : <span style="color: 'black'">{{ summaryData?.totalPV_tobe_done ? summaryData?.totalPV_tobe_done : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'TOTAL_PHYSICAL_VERIFICATION' | translate}} : <span style="color: 'black'">{{ summaryData?.totalPV_tobe_done ? summaryData?.totalPV_tobe_done : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'COMPLETED'| translate}}</h5>
                            <h3>{{ summaryData?.PVCompleted ? summaryData?.PVCompleted : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.PV_Pending ? summaryData?.PV_Pending : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-eight">
                <!-- <div class="box-header">
                    <h4>{{ 'TOTAL_SUBSIDY_CALCULATED' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalApplicationswithDMIforSubsidy_Approval ? summaryData?.TotalApplicationswithDMIforSubsidy_Approval : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'TOTAL_SUBSIDY_CALCULATED' | translate}} : <span style="color: 'black'">{{ summaryData?.TotalApplicationswithDMIforSubsidy_Approval ? summaryData?.TotalApplicationswithDMIforSubsidy_Approval : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'CALCULATED'| translate}}</h5>
                            <h3>{{ summaryData?.Applications_Approved_at_Administartion ? summaryData?.Applications_Approved_at_Administartion : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.Pending_Subsidy_Calculation ? summaryData?.Pending_Subsidy_Calculation : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
            <div class="box box-nine">
                <!-- <div class="box-header">
                    <h4>{{ 'TOTAL_SUBSIDY_DISBURSED' | translate}} : <span style="color: 'black'">{{ summaryData?.total_Application_For_Payment_By_CAO ? summaryData?.total_Application_For_Payment_By_CAO : 0}}</span></h4>
                </div> -->
                <p-panel [toggleable]="true" [collapsed]="true">
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-2" class="box-header">
                            <h4>{{ 'TOTAL_SUBSIDY_DISBURSED' | translate}} : <span style="color: 'black'">{{ summaryData?.total_Application_For_Payment_By_CAO ? summaryData?.total_Application_For_Payment_By_CAO : 0 }}</span></h4>
                        </div>
                    </ng-template>
                    <div class="box-main">
                        <div class="left">
                            <h5>{{'DISBURSED'| translate}}</h5>
                            <h3>{{ summaryData?.Payment_Done_Application_By_CAO ? summaryData?.Payment_Done_Application_By_CAO : 0 }}</h3>
                        </div>
                        
                        <div class="right">
                            <h5>{{'PENDING(I+R)'| translate}}</h5>
                            <h3>{{ summaryData?.Pending_Application_For_Payment_By_CAO ? summaryData?.Pending_Application_For_Payment_By_CAO : 0 }}</h3>
                        </div>
                    </div>
                </p-panel>
            </div>
           
        </div>
    </div>
</div>

<div *ngIf="false" class="card p-fluid p-formgrid grid filter-card">
    <div class="field col-12 md:col-2">
        <!-- <label style="margin-right:4px;">{{'CROP_TYPE'| translate }}</label> -->
        <p-dropdown [options]="cropTypeList" [(ngModel)]="selectedCrop"
            placeholder="{{'Crop'| translate}}" optionLabel="label" optionValue="data"
            (ngModelChange)="getCropTypeName($event)">
        </p-dropdown>
        <!-- <div *ngIf="(isSubmitted || f.cropType.touched) && f.cropType.errors" class="invalid-feedback">
            <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
        </div> -->
    </div>

    <div class="field col-12 md:col-2">
        <!-- <label htmlFor="selectProgramme">{{'PROGRAMME_NAME'| translate}}</label> -->
        <p-dropdown [options]="program" [(ngModel)]="selectedProgram"
            placeholder="{{'MI System'| translate}}" optionLabel=""></p-dropdown>
        <!-- <div class="grid-item">
        </div> -->
    </div>

    <div class="field col-12 md:col-2">
        <!-- <label htmlFor="selectCaste">{{'CASTE'| translate}}</label> -->
        <p-dropdown [options]="caste" [(ngModel)]="selectedCaste"
            placeholder="{{'Caste'| translate}}" optionLabel="name"></p-dropdown>
    </div>

    <div class="field col-12 md:col-2">
        <!-- <label htmlFor="selectAppType">{{'APPLICATION_TYPE'| translate}}</label> -->
        <p-dropdown [options]="appType" [(ngModel)]="selectedAppType"
            placeholder="{{'Applicant'| translate}}" optionLabel="name"></p-dropdown>
    </div>

    <div class="d-flex justify-content-center">
        <button pButton pRipple label="Submit" class="p-button-success" label="{{'APPLY_FILTER' | translate}}" (click)="getTotalRecord()"></button>
    </div>
</div>
<!-- extra code end -->


<div class="p-fluid p-formgrid justify-content-between" style="display: flex; flex-wrap:wrap">
    <!-- <div class="field md:col-4 col-6">
        <label [style]="{ color: 'rgb(168, 32, 32)', 'font-size': '1.2rem', 'font-weight': 'bold' }">{{'FINANCIAL_YEAR'| translate}}: 
            <label [style]="{ color: 'black', 'font-size': '1.2rem', 'font-weight': 'bold' }">
            {{  selectedYear == '' ? 'All' : selectedYear }}</label>
        </label>
    </div> -->
    <div class="field md:col-5 col-12 header-finyear-block">
        <label class="mx-1 mt-2" [style]="{ color: 'rgb(168, 32, 32)', 'font-size': '1.2rem', 'font-weight': 'bold' }">{{'FINANCIAL_YEAR'| translate }}</label>
        <p-dropdown [style]="{'min-width': '10rem'}" [options]="finYearData" [(ngModel)]="selectedFinYear"
            placeholder="{{'FINANCIAL_YEAR'| translate}}" optionLabel="year"
            (onChange)="onFinYearChange()">
        </p-dropdown>
    </div>

    <div *ngIf="userID=='admin' || userID=='cao'" class="field md:col-3 col-6">
        <div class="component-box" [ngClass]="{'selected': isMIChecked}">
            <div class="componentName" (click)="onComponentBoxClick('MI')">{{ 'MI' | translate}}</div>
        </div>
    </div>
    <div *ngIf="userID=='admin' || userID=='cao'" class="field md:col-3 col-6">
        <div class="component-box" [ngClass]="{'selected': isPondChecked}">
            <div class="componentName" (click)="onComponentBoxClick('Pond')">{{ 'POND/TANK' | translate}}</div>
        </div>
    </div>
    <div class="field md:col-1 col-3">
        <button (click)="refreshData()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button>
    </div>
    <!-- <p-button size="small" class="" label="{{'TOTAL_RECORD' | translate}}" (click)="getTotalRecord()"></p-button> -->
</div>

<!-- <div class="" *ngIf="userID=='admin' || userID=='cao'">
    <div class="p-fluid p-formgrid" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-3 col-6">
            <div class="component-box" [ngClass]="{'selected': isMIChecked}">
                <div class="componentName" (click)="onComponentBoxClick('MI')">{{ 'MI' | translate}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="component-box" [ngClass]="{'selected': isPondChecked}">
                <div class="componentName" (click)="onComponentBoxClick('Pond')">{{ 'POND/TANK' | translate}}</div>
            </div>
        </div>
    </div>
</div> -->

<div class="card" *ngIf="isMIChecked">
    <div class="p-fluid p-formgrid" style="display: flex; flex-wrap: wrap; justify-content: center;">
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box clickable" (click)="onClickMITotalAppRep()">
                <div class="total">{{ 'TOTAL_APPLICATIONS' | translate}}</div>
                <!-- <div *ngIf="card1CountData?.totalApp" class="count" (click)="onClickMIBox('Total Number of Applications', 1)">{{ card1CountData?.totalApp | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.TotalArea | number:'1.0-0'}} ac. </p></div> -->
                <div *ngIf="card1CountData?.totalApp != null" class="count">{{ card1CountData?.totalApp | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.TotalArea | number:'1.0-0'}} acres </p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box">
                <div class="total">{{ 'COMPLETED_APPLICATIONS' | translate}}</div>
                <!-- <div *ngIf="card1CountData?.verifiedEstApproved" class="count" (click)="onClickMIBox('Total Completed Application', 2)">{{ card1CountData?.verifiedEstApproved | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.verifiedEstApprovedArea | number:'1.0-0'}} ac.</p></div> -->
                <div *ngIf="card1CountData?.CompletedApps != null" class="count">{{ card1CountData?.CompletedApps | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.CompletedAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box clickable" (click)="onClickMIBox('Total Pending Applications', 3)">
                <div class="total">{{ 'UNDER_PROCESS_APPLICATIONS' | translate}}</div>
                <div *ngIf="card1CountData?.UnProcessedApps != null" class="count">{{ card1CountData?.UnProcessedApps | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.UnProcessedAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box">
                <div class="total">{{ 'REJECTED_APPLICATION' | translate}}</div>
                <!-- <div *ngIf="card1CountData?.rejectedApp" class="count" (click)="onClickMIBox('Total Rejected Applications', 4)">{{ card1CountData?.rejectedApp | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.rejectedAppsArea | number:'1.0-0'}} ac.</p></div> -->
                <div *ngIf="card1CountData?.rejectedApp != null" class="count">{{ card1CountData?.rejectedApp | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.rejectedAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box">
                <div class="total">{{ 'INCOMPLETE_APPLICATION' | translate}}</div>
                <!-- <div *ngIf="card1CountData?.InCompleteApps" class="count" (click)="onClickMIBox('Total Rejected Applications', 5)">{{ card1CountData?.InCompleteApps | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.InCompleteAppsArea | number:'1.0-0'}} ac.</p></div> -->
                <div *ngIf="card1CountData?.InCompleteApps != null" class="count">{{ card1CountData?.InCompleteApps | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.InCompleteAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        <!-- <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'ESTIMATE_APPROVAL_DONE' | translate}}</div>
                <div class="count" (click)="onClickMIBox('Estimate Approval Done', 5)">{{ card1CountData?.verifiedEstApproved | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'CHALLAN_DEPOSITED' | translate}}</div>
                <div class="count" (click)="onClickMIBox('Challan Deposited', 6)">{{ card1CountData?.ChallanDeposited | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'INSTALLATIONS_DONE' | translate}}</div>
                <div class="count" (click)="onClickMIBox('Installations Done', 7)">{{ card1CountData?.BOQUploaded | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'PHYSICAL_VERIFICATION_DONE' | translate}}</div>
                <div class="count" (click)="onClickMIBox('Physical Verification Done', 8)">{{ card1CountData?.PVCompleted | number:'1.0-2'}}</div>
            </div>
        </div> -->
    </div>
</div>

<div class="card" *ngIf="isPondChecked">
    <div class="p-fluid p-formgrid" style="display: flex; flex-wrap: wrap; justify-content: center;">
        <div class="field md:col-3 col-6">
            <div class="box clickable" (click)="onClickPondTotalAppRep()">
            <!-- <div class="box"> -->
                <div class="total">{{ 'TOTAL_APPLICATIONS' | translate}}</div>
                <!-- <div *ngIf="card1CountData?.totalApp" class="count" (click)="onClickPondBox('Total Number of Applications', 1)">{{ pondCard1CountData?.totalApp | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ pondCard1CountData?.TotalArea | number:'1.0-0'}} ac. </p></div> -->
                <div *ngIf="pondCard1CountData?.totalApp != null" class="count">{{ pondCard1CountData?.totalApp | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ pondCard1CountData?.TotalArea | number:'1.0-0'}} acres </p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box">
                <div class="total">{{ 'COMPLETED_APPLICATIONS' | translate}}</div>
                <!-- <div *ngIf="pondCard1CountData?.verifiedEstApproved" class="count" (click)="onClickPondBox('Total Completed Application', 2)">{{ pondCard1CountData?.verifiedEstApproved | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.verifiedEstApprovedArea | number:'1.0-0'}} ac.</p></div> -->
                <div *ngIf="pondCard1CountData?.CompletedApps != null" class="count">{{ pondCard1CountData?.CompletedApps | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ pondCard1CountData?.CompletedAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box clickable" (click)="onClickPondBox('Under Process Applications', '3')">
                <div class="total">{{ 'UNDER_PROCESS_APPLICATIONS' | translate}}</div>
                <div *ngIf="pondCard1CountData?.UnProcessedApps != null" class="count">{{ pondCard1CountData?.UnProcessedApps | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ pondCard1CountData?.UnProcessedAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box">
                <div class="total">{{ 'REJECTED_APPLICATION' | translate}}</div>
                <!-- <div *ngIf="pondCard1CountData?.rejectedApp" class="count" (click)="onClickPondBox('Total Rejected Applications', 4)">{{ pondCard1CountData?.rejectedApp | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ pondCard1CountData?.rejectedAppsArea | number:'1.0-0'}} ac.</p></div> -->
                <div *ngIf="pondCard1CountData?.rejectedApp != null" class="count">{{ pondCard1CountData?.rejectedApp | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ pondCard1CountData?.rejectedAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        <div class="field md:col-3 col-6" style="max-width: 250px;">
            <div class="box">
                <div class="total">{{ 'INCOMPLETE_APPLICATION' | translate}}</div>
                <!-- <div *ngIf="pondCard1CountData?.InCompleteApps" class="count" (click)="onClickPondBox('Total Rejected Applications', 5)">{{ pondCard1CountData?.InCompleteApps | number:'1.0-2'}} | <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ card1CountData?.InCompleteAppsArea | number:'1.0-0'}} ac.</p></div> -->
                <div *ngIf="pondCard1CountData?.InCompleteApps != null" class="count">{{ pondCard1CountData?.InCompleteApps | number:'1.0-2'}}  <p style="font-size:16px; color:rgb(168, 15, 15);"> {{ pondCard1CountData?.InCompleteAppsArea | number:'1.0-0'}} acres</p></div>
            </div>
        </div>
        


        <!-- <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_1_INTIMATION' | translate}}</div>
                <div class="count" (click)="onClickPondBox('Total Number of Applications', 1)">{{ pondCard1CountData?.Ist_intimation | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_2_INTIMATION' | translate}}</div>
                <div class="count" (click)="onClickPondBox('Total Approved Application', 2)">{{ pondCard1CountData?.IInd_intimation | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_STAGE_1_PHYSICAL_VERIFICATION' | translate}}</div>
                <div class="count" (click)="onClickPondBox('Total Pending Applications', 3)">{{ pondCard1CountData?.Total_pond_pv_stage1 | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_STAGE_2_PHYSICAL_VERIFICATION' | translate}}</div>
                <div class="count" (click)="onClickPondBox('Total Rejected Applications', 4)">{{ pondCard1CountData?.Total_pond_pv_stage2 | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_STAGE_1_SUBSIDY_DISBURSED' | translate}}</div>
                <div class="count" (click)="onClickPondBox('Estimate Approval Done', 5)">{{ pondCard1CountData?.Total_Stage1_Subsidy | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_STAGE_2_SUBSIDY_DISBURSED' | translate}}</div>
                <div class="count" (click)="onClickPondBox('Estimate Approval Done', 5)">{{ pondCard1CountData?.Total_Stage2_Subsidy | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_STAGE_3_SUBSIDY_DISBURSED' | translate}}</div>
                <div class="count" (click)="onClickPondBox('Estimate Approval Done', 5)">{{ pondCard1CountData?.Total_Stage3_Subsidy | number:'1.0-2'}}</div>
            </div>
        </div> -->
        <!-- <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">Installations Done</div>
                <div class="count" (click)="onClickPondBox('Installations Done', 7)">{{ pondCard1CountData?.BOQUploaded | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">Physical Verification Done</div>
                <div class="count" (click)="onClickPondBox('Physical Verification Done', 8)">{{ pondCard1CountData?.PVCompleted | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">Challan Deposited</div>
                <div class="count" (click)="onClickPondBox('Challan Deposited', 6)">{{ pondCard1CountData?.ChallanDeposited | number:'1.0-2'}}</div>
            </div>
        </div> -->
    </div>
</div>

<!-- <div class="card" *ngIf="isSolarChecked">
    <div class="p-fluid p-formgrid" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_NO_OF_APPLICATIONS' | translate}}</div>
                <div class="count" (click)="onClickSolarBox('Total Number of Applications', 1)">{{ solarCard1CountData?.totalApp | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_COMPLETED_APPLICATIONS' | translate}}</div>
                <div class="count" (click)="onClickSolarBox('Total Completed Application', 2)">{{ solarCard1CountData?.TotalApprovedApp | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'CHALLAN_GENERATED' | translate}}</div>
                <div class="count" (click)="onClickSolarBox('Estimate Approval Done', 5)">{{ solarCard1CountData?.challanGenerated | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'INSTALLATIONS_DONE' | translate}}</div>
                <div class="count" (click)="onClickSolarBox('Installations Done', 7)">{{ solarCard1CountData?.installDone | number:'1.0-2'}}</div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="card" *ngIf="isWaterCourseChecked">
    <div class="p-fluid p-formgrid" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_NO_OF_APPLICATIONS' | translate}}</div>
                <div class="count" (click)="onClickSolarBox('Total Number of Applications', 1)">{{ waterCourseCard1CountData?.totalApp | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'TOTAL_COMPLETED_APPLICATIONS' | translate}}</div>
                <div class="count" (click)="onClickSolarBox('Total Completed Application', 2)">{{ waterCourseCard1CountData?.TotalApprovedApp | number:'1.0-2'}}</div>
            </div>
        </div>
        <div class="field md:col-3 col-6">
            <div class="box">
                <div class="total">{{ 'WORK_DONE' | translate}}</div>
                <div class="count" (click)="onClickSolarBox('Estimate Approval Done', 5)">{{ waterCourseCard1CountData?.workDone | number:'1.0-2'}}</div>
            </div>
        </div>
    </div>
</div> -->
  

<!-- <div class="card" *ngIf="data1 && isMIChecked">
    <p [style]="{color: 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{'Number of Application by District'}}</p>
    <p-chart type="bar" [data]="data1" [options]="options1"></p-chart>
</div> -->
<div class="card" *ngIf="pieChartData && (isMIChecked || isPondChecked)">
    <div class="p-fluid p-formgrid" style="display: flex; flex-wrap: wrap; justify-content: center;">
        <div class="field md:col-6 col-12">
            <h5>{{''}}</h5>
            <p-chart #pieChart type="pie" [data]="pieChartData" width="400" height="400"></p-chart>
            <!-- <p-chart #pieChart type="pie" [data]="pieChartData"></p-chart> -->
        </div>
        <!-- <div class="field md:col-6 col-12" *ngIf="isMIChecked">
            <p [style]="{color: 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{'Monthly Variation in Applications Recieved and Disbursed'}}</p>
            <p-chart #lineChart type="line" [data]="lineGraphData" width="400" height="400"></p-chart>
        </div> -->
    </div>
</div>
















<!-- use less old code -->
<p-panel [toggleable]="true" [collapsed]="true" *ngIf="false">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <span class="font-bold">{{'MI_CONSOLIDATED_REPORT_DETAILS'| translate}}</span>
        </div>
    </ng-template>
    
    <!-- <p-card styleClass="p-card-shadow mt-2"> -->
    <div class="dashboardTable">
    <!-- <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <p-button label="{{'TOTAL_RECORD' | translate}}" (click)="getTotalRecord()"></p-button>
        </ng-template>

        <ng-template pTemplate="right">
            <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                class="p-button-help"></button>

            <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
        </ng-template>
    </p-toolbar> -->
    <p-table #miSurvey [value]="consolidateData" dataKey="AppId_ProgID" [rows]="10" [paginator]="false" 
        [globalFilterFields]="[
    'District',
    'totalApp',
    'TotalArea',
    'VerifiedApp',
    'verifiedAppArea',
    'PendingApp',
    'IncompleteApp',
    'incompleteAppArea',
    'rejectApp',
    'totalEstimatedApp',
    'totalEstimatedArea',
    'verifiedEstimateApp',
    'verifiedEstimateArea',
    'pendingEstimateApp',
    'verifiedEstApproved',
    'verifiedEstApprovedArea',
    'pendingEstApproved',
    'rejectedEstVerified',
    'ChallanGenerated',
    'ChallanDeposited',
    'BOQUploaded',
    'BOQMIArea',
    'BOQPending',
    'PVCompleted',
    'PV_MI_Area',
    'PV_Pending_with_JE',
    'PV_Pending_with_XEN',
    'Pending_Subsidy_Calculation',
    'ApplicationswithDMIforSubsidy_Approval',
    'Applications_Approved_at_Administartion',
    'Subsisdy_Approved_MI_Area',
    'AssistanceAmount',
    'Pending_Application_For_Payment_By_CAO',
    'Payment_Done_Application_By_CAO',
    'Payment_done_MI_Area',


    ]" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" (onFilter)="tableDataFunction($event)" (onPage)="onPage($event)"
        [loading]="loading" [scrollable]="true" scrollHeight="500px" responsiveLayout="scroll" [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '400rem'}">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'MI_CONSOLIDATED_REPORT'| translate}}</h5>
                <!-- <p-toolbar> -->
                    <!-- <ng-template pTemplate="left"> -->
                    <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                            class="p-button-success"></button> -->
                    <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                    <!-- </ng-template> -->
                    <!-- <ng-template pTemplate="left">
                        <h6 style="margin-right: 20px;">Select Financial Year: </h6>
                        <p-dropdown  [options]="financialYears" [(ngModel)]="selectedYear" [editable]="true" optionLabel="name" (onChange)="financialYearChange($event)"></p-dropdown>
                    </ng-template> -->
                    <!-- <ng-template pTemplate="left">
                        <p-button class="mx-4" label="{{'TOTAL_RECORD' | translate}}" (click)="getTotalRecord()"></p-button>
                    </ng-template> -->
        
                    <div class="flex align-items-center justify-content-center">
                        <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                        <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-download"
                            class="p-button-help"></button>
        
                        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    </div>
                <!-- </p-toolbar> -->
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="header-sec-one">
                <th pFrozenColumn [ngClass]="{'row-accessories': true}"></th>

                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <!-- <th pFrozenColumn [ngClass]="{'row-accessories': true}"></th> -->
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                <th class="top-header-1"></th>
                <th class="top-header-1"></th>
                <th class="top-header-1"></th>
                <th class="top-header-1">{{'APPLICATION_APPROVAL1'| translate}}</th>
                <th class="top-header-1"></th>
                <th class="top-header-1"></th>
                <th class="top-header-1"></th>
                <th class="top-header-1"></th>

                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-2"></th>
                <th class="top-header-2"></th>
                <th class="top-header-2">{{'ESTIMATE'| translate}} </th>
                <th class="top-header-2"></th>
                <th class="top-header-2"></th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                <th class="top-header-3"></th>
                <th class="top-header-3">{{'ESTIMATE_APPROVAL1'| translate}}</th>
                <th class="top-header-3"></th>
                <th class="top-header-3"></th>

                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                <th class="top-header-4">{{'CHALLAN1'| translate}}</th>
                <th class="top-header-4"></th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-5"></th>
                <th class="top-header-5">{{'BOQ'| translate}}</th>
                <th class="top-header-5"></th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-6"></th>
                <th class="top-header-6"></th>
                <th class="top-header-6">{{'PV'| translate}}</th>
                <th class="top-header-6"></th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-7"></th>
                <th class="top-header-7"></th>
                <th class="top-header-7">{{'SUBSIDY_CALCULATION1'| translate}}</th>
                <th class="top-header-7"></th>
                <th class="top-header-7"></th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-8"></th>
                <th class="top-header-8">{{'SUBSIDY'| translate}}</th>
                <th class="top-header-8"></th>
            </tr>

            <tr class="header-sec-row">
                <!-- <th pFrozenColumn pSortableColumn="District">{{'FINANCIAL_YEAR'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th> -->
                <th pFrozenColumn pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <!-- <th pSortableColumn="Block">{{'BLOCK'| translate}}
                    <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                    <p-sortIcon field="Block"></p-sortIcon>
                </th>
                <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                    <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                    <p-sortIcon field="Constituency"></p-sortIcon>
                </th> -->
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-1" pSortableColumn="totalApp">{{'TOTAL_APP'| translate}}
                    <p-columnFilter class="filter" type="text" field="totalApp" display="menu"></p-columnFilter>
                    <p-sortIcon class="sort" field="totalApp"></p-sortIcon>
                </th>
                <th class="top-header-1" pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                    <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalArea"></p-sortIcon>
                </th>
                <th class="top-header-1" pSortableColumn="VerifiedApp">{{'VERIFIED_APP'| translate}}
                    <p-columnFilter type="text" field="VerifiedApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="VerifiedApp"></p-sortIcon>
                </th>
                <th class="top-header-1" pSortableColumn="verifiedAppArea">{{'VERIFIED_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="verifiedAppArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedAppArea"></p-sortIcon>
                </th>
                <th class="top-header-1" pSortableColumn="PendingApp">{{'PENDING_APP'| translate}}
                    <p-columnFilter type="text" field="PendingApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="PendingApp"></p-sortIcon>
                </th>
                <th class="top-header-1" pSortableColumn="IncompleteApp">{{'INCOMPLETE_APP'| translate}}
                    <p-columnFilter type="text" field="IncompleteApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="IncompleteApp"></p-sortIcon>
                </th>
                <th class="top-header-1" pSortableColumn="incompleteAppArea">{{'INCOMPLETE_APP_AREA'| translate}}
                    <p-columnFilter type="text" field="incompleteAppArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="incompleteAppArea"></p-sortIcon>
                </th>
                <th class="top-header-1" pSortableColumn="rejectApp">{{'REJECTED_APP'| translate}}
                    <p-columnFilter type="text" field="rejectApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="rejectApp"></p-sortIcon>
                </th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-2" pSortableColumn="totalEstimatedApp">{{'TOTAL_ESTIMATED_APP'| translate}}
                    <p-columnFilter type="text" field="totalEstimatedApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="totalEstimatedApp"></p-sortIcon>
                </th>
                <th class="top-header-2" pSortableColumn="totalEstimatedArea">{{'TOTAL_ESTIMATED_AREA'| translate}}
                    <p-columnFilter type="text" field="totalEstimatedArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="totalEstimatedArea"></p-sortIcon>
                </th>
                <th class="top-header-2" pSortableColumn="pendingEstimateApp">{{'PENDING_ESTIMATE_APP'| translate}}
                    <p-columnFilter type="text" field="pendingEstimateApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="pendingEstimateApp"></p-sortIcon>
                </th>
                <th class="top-header-2" pSortableColumn="verifiedEstimateApp">{{'VERIFIED_ESTIMATE_APP'| translate}}
                    <p-columnFilter type="text" field="verifiedEstimateApp" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstimateApp"></p-sortIcon>
                </th>
                <th class="top-header-2" pSortableColumn="verifiedEstimateArea">{{'VERIFIED_ESTIMATE_AREA'| translate}}
                    <p-columnFilter type="text" field="verifiedEstimateArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstimateArea"></p-sortIcon>
                </th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                <th class="top-header-3" pSortableColumn="verifiedEstApproved">{{'VERIFIED_ESTIMATE_APPROVED'| translate}}
                    <p-columnFilter type="text" field="verifiedEstApproved" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstApproved"></p-sortIcon>
                </th>
                <th class="top-header-3" pSortableColumn="verifiedEstApprovedArea">{{'VERIFIED_ESTIMATE_APPROVED_AREA'| translate}}
                    <p-columnFilter type="text" field="verifiedEstApprovedArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="verifiedEstApprovedArea"></p-sortIcon>
                </th>
                <th class="top-header-3" pSortableColumn="pendingEstApproved">{{'PENDING_ESTIMATE_APPROVED'| translate}}
                    <p-columnFilter type="text" field="pendingEstApproved" display="menu"></p-columnFilter>
                    <p-sortIcon field="pendingEstApproved"></p-sortIcon>
                </th>
                <th class="top-header-3" pSortableColumn="rejectedEstVerified">{{'REJECTED_ESTIMATE_VERIFIED'| translate}}
                    <p-columnFilter type="text" field="rejectedEstVerified" display="menu"></p-columnFilter>
                    <p-sortIcon field="rejectedEstVerified"></p-sortIcon>
                </th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-4" pSortableColumn="ChallanGenerated">{{'CHALLAN_GENERATED'| translate}}
                    <p-columnFilter type="text" field="ChallanGenerated" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanGenerated"></p-sortIcon>
                </th>
                <th class="top-header-4" pSortableColumn="ChallanDeposited">{{'CHALLAN_DEPOSITED'| translate}}
                    <p-columnFilter type="text" field="ChallanDeposited" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanDeposited"></p-sortIcon>
                </th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-5" pSortableColumn="BOQUploaded">{{'BOQ_UPLOADED'| translate}}
                    <p-columnFilter type="text" field="BOQUploaded" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQUploaded"></p-sortIcon>
                </th>
                <th class="top-header-5" pSortableColumn="BOQMIArea">{{'BOQ_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="BOQMIArea" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQMIArea"></p-sortIcon>
                </th>
                <th class="top-header-5" pSortableColumn="BOQPending">{{'BOQ_PENDING'| translate}}
                    <p-columnFilter type="text" field="BOQPending" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQPending"></p-sortIcon>
                </th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-6" pSortableColumn="PVCompleted">{{'PV_COMPLETED'| translate}}
                    <p-columnFilter type="text" field="PVCompleted" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVCompleted"></p-sortIcon>
                </th>
                <th class="top-header-6" pSortableColumn="PV_MI_Area">{{'PV_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="PV_MI_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_MI_Area"></p-sortIcon>
                </th>
                <th class="top-header-6" pSortableColumn="PV_Pending_with_JE">{{'PV_PENDING_WITH_JE'| translate}}
                    <p-columnFilter type="text" field="PV_Pending_with_JE" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_Pending_with_JE"></p-sortIcon>
                </th>
                <th class="top-header-6" pSortableColumn="PV_Pending_with_XEN">{{'PV_PENDING_WITH_XEN'| translate}}
                    <p-columnFilter type="text" field="PV_Pending_with_XEN" display="menu"></p-columnFilter>
                    <p-sortIcon field="PV_Pending_with_XEN"></p-sortIcon>
                </th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-7" pSortableColumn="ApplicationswithDMIforSubsidy_Approval">{{'APP_WITH_DMI_SUBSIDY_APPROVAL'|
                    translate}}
                    <p-columnFilter type="text" field="ApplicationswithDMIforSubsidy_Approval"
                    display="menu"></p-columnFilter>
                    <p-sortIcon field="ApplicationswithDMIforSubsidy_Approval"></p-sortIcon>
                </th>
                <th class="top-header-7" pSortableColumn="Applications_Approved_at_Administartion">{{'APP_APPROVED_AT_ADMINISTRATION'|
                    translate}}
                    <p-columnFilter type="text" field="Applications_Approved_at_Administartion"
                    display="menu"></p-columnFilter>
                    <p-sortIcon field="Applications_Approved_at_Administartion"></p-sortIcon>
                </th>
                <th class="top-header-7" pSortableColumn="Pending_Subsidy_Calculation">{{'PENDING_SUBSIDY_CALCULATION'| translate}}
                    <p-columnFilter type="text" field="Pending_Subsidy_Calculation" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_Subsidy_Calculation"></p-sortIcon>
                </th>
                <th class="top-header-7" pSortableColumn="Subsisdy_Approved_MI_Area">{{'SUBSIDY_APPROVED_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="Subsisdy_Approved_MI_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Subsisdy_Approved_MI_Area"></p-sortIcon>
                </th>
                <th class="top-header-7" pSortableColumn="AssistanceAmount">{{'ASSISTANCE_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="AssistanceAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="AssistanceAmount"></p-sortIcon>
                </th>
                <!-- <th [ngClass]="{'row-accessories': true}"></th> -->
                <th class="top-header-8" pSortableColumn="Pending_Application_For_Payment_By_CAO">{{'PENDING_APP_FOR_PAYMENT_BY_CAO'|
                    translate}}
                    <p-columnFilter type="text" field="Pending_Application_For_Payment_By_CAO"
                        display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_Application_For_Payment_By_CAO"></p-sortIcon>
                </th>
                <th class="top-header-8" pSortableColumn="Payment_Done_Application_By_CAO">{{'PAYMENT_DONE_APP_BY_CAO'| translate}}
                    <p-columnFilter type="text" field="Payment_Done_Application_By_CAO"
                        display="menu"></p-columnFilter>
                    <p-sortIcon field="Payment_Done_Application_By_CAO"></p-sortIcon>
                </th>
                <th class="top-header-8" pSortableColumn="Payment_done_MI_Area">{{'PAYMENT_DONE_MI_AREA'| translate}}
                    <p-columnFilter type="text" field="Payment_done_MI_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Payment_done_MI_Area"></p-sortIcon>
                </th>

            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-consolidateData>
            <tr class="body-section">
                <!-- <td pFrozenColumn>{{ selectedYear == '' ? 'All': selectedYear }}</td> -->
                <td pFrozenColumn>{{consolidateData.District}}</td>
                <!-- <td>{{consolidateData.Block}}</td>
                <td>{{consolidateData.Constituency}}</td> -->
                <!-- <td></td> -->
                <td>{{consolidateData.totalApp}}</td>
                <td>{{consolidateData.TotalArea}}</td>
                <td>{{consolidateData.VerifiedApp}}</td>
                <td>{{consolidateData.verifiedAppArea}}</td>
                <!-- <td>{{consolidateData.PendingApp}}</td> -->
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'AppVerification')">{{ consolidateData.PendingApp }}</a></td>
                <td>{{consolidateData.IncompleteApp}}</td>
                <td>{{consolidateData.incompleteAppArea}}</td>
                <td>{{consolidateData.rejectApp}}</td>
                <!-- <td></td> -->
                <td>{{consolidateData.totalEstimatedApp}}</td>
                <td>{{consolidateData.totalEstimatedArea}}</td>
                <!-- <td>{{consolidateData.pendingEstimateApp}}</td> -->
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'Estimation')">{{ consolidateData.pendingEstimateApp }}</a></td>
                <td>{{consolidateData.verifiedEstimateApp}}</td>
                <td>{{consolidateData.verifiedEstimateArea}}</td>
                <!-- <td></td> -->


                <td>{{consolidateData.verifiedEstApproved}}</td>
                <td>{{consolidateData.verifiedEstApprovedArea}}</td>
                <!-- <td>{{consolidateData.pendingEstApproved}}</td> -->
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'EstVerification')">{{ consolidateData.pendingEstApproved }}</a></td>
                <td>{{consolidateData.rejectedEstVerified}}</td>
                <!-- <td></td> -->
                <td>{{consolidateData.ChallanGenerated}}</td>
                <td>{{consolidateData.ChallanDeposited}}</td>
                <!-- <td></td> -->
                <td>{{consolidateData.BOQUploaded}}</td>
                <td>{{consolidateData.BOQMIArea}}</td>
                <!-- <td>{{consolidateData.BOQPending}}</td> -->
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'BOQ')">{{ consolidateData.BOQPending }}</a></td>

                <!-- <td></td> -->
                <td>{{consolidateData.PVCompleted}}</td>
                <td>{{consolidateData.PV_MI_Area}}</td>
                <!-- <td>{{consolidateData.PV_Pending_with_JE}}</td> -->
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'PVVerification', 'JE')">{{ consolidateData.PV_Pending_with_JE }}</a></td>
                <!-- <td>{{consolidateData.PV_Pending_with_XEN}}</td> -->
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'PVVerification', 'XEN')">{{ consolidateData.PV_Pending_with_XEN }}</a></td>
                <!-- <td></td> -->

                <!-- <td>{{consolidateData.Pending_Subsidy_Calculation}}</td> -->
                <td>{{consolidateData.ApplicationswithDMIforSubsidy_Approval}}</td>
                <td>{{consolidateData.Applications_Approved_at_Administartion}}</td>
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'Subsidy')">{{ consolidateData.Pending_Subsidy_Calculation }}</a></td>
                <td>{{consolidateData.Subsisdy_Approved_MI_Area}}</td>
                <td>{{consolidateData.AssistanceAmount}}</td>
                <!-- <td></td> -->

                <!-- <td>{{consolidateData.Pending_Application_For_Payment_By_CAO}}</td> -->
                <td><a class="link_pointer" (click)="showPendingDetailUserDialog(consolidateData, 'stf,stv')">{{ consolidateData.Pending_Application_For_Payment_By_CAO }}</a></td>
                <td>{{consolidateData.Payment_Done_Application_By_CAO}}</td>
                <td>{{consolidateData.Payment_done_MI_Area}}</td>

            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <!-- <tr>
                <td class="total-col" style="font-weight: bold; color: 'rgb(168, 32, 32)'"> Total</td>
                <td class="total-col"></td>
                <td class="total-col"></td>
                <td class="total-col">{{totalApp | number:'1.0-2'}}</td>
                <td class="total-col">{{totalArea | number:'1.0-2'}}</td>
                <td class="total-col">{{verifiedApp | number:'1.0-2'}}</td>
                <td class="total-col">{{verifiedAppArea | number:'1.0-2'}}</td>
                <td class="total-col">{{pendingApp | number:'1.0-2'}}</td>
                <td class="total-col">{{incompleteApp | number:'1.0-2'}}</td>
                <td class="total-col">{{incompleteAppArea | number:'1.0-2'}}</td>
                <td class="total-col">{{rejectApp | number:'1.0-2'}}</td>
                <td class="total-col"></td>
                <td class="total-col">{{totalEstimatedApp | number:'1.0-2'}}</td>
                <td class="total-col">{{totalEstimatedArea | number:'1.0-2'}}</td>
                <td class="total-col">{{pendingEstimateApp | number:'1.0-2'}}</td>
                <td class="total-col">{{verifiedEstimateApp | number:'1.0-2'}}</td>
                <td class="total-col">{{verifiedEstimateArea | number:'1.0-2'}}</td>
                <td class="total-col"></td>
                <td class="total-col">{{verifiedEstApproved | number:'1.0-2'}}</td>
                <td class="total-col">{{verifiedEstApprovedArea | number:'1.0-2'}}</td>
                <td class="total-col">{{pendingEstApproved | number:'1.0-2'}}</td>
                <td class="total-col">{{rejectedEstVerified | number:'1.0-2'}}</td>
                <td class="total-col"></td>
                <td class="total-col">{{challanGenerated | number:'1.0-2'}}</td>
                <td class="total-col">{{challanDeposited | number:'1.0-2'}}</td>
                <td class="total-col"></td>
                <td class="total-col">{{BOQUploaded | number:'1.0-2'}}</td>
                <td class="total-col">{{BOQMIArea | number:'1.0-2'}}</td>
                <td class="total-col">{{BOQPending | number:'1.0-2'}}</td>
                <td class="total-col"></td>
                <td class="total-col">{{PVCompleted | number:'1.0-2'}}</td>
                <td class="total-col">{{PV_MI_Area | number:'1.0-2'}}</td>
                <td class="total-col">{{PV_Pending_with_JE | number:'1.0-2'}}</td>
                <td class="total-col">{{PV_Pending_with_XEN | number:'1.0-2'}}</td>
                <td class="total-col"></td>
                <td class="total-col">{{applicationswithDMIforSubsidy_Approval | number:'1.0-2'}}</td>
                <td class="total-col">{{applications_Approved_at_Administartion | number:'1.0-2'}}</td>
                <td class="total-col">{{pending_Subsidy_Calculation | number:'1.0-2'}}</td>
                <td class="total-col">{{subsisdy_Approved_MI_Area | number:'1.0-2'}}</td>
                <td class="total-col">{{assistanceAmount | number:'1.0-2'}}</td>
                <td class="total-col"></td>
                <td class="total-col">{{pending_Application_For_Payment_By_CAO | number:'1.0-2'}}</td>
                <td class="total-col">{{payment_Done_Application_By_CAO | number:'1.0-2'}}</td>
                <td class="total-col">{{payment_done_MI_Area | number:'1.0-2'}}</td>
            </tr> -->

            <tr *ngIf="consolidateData?.length > 0" class="footer-section">
                <td pFrozenColumn class="grand-total-col"> Total </td>
                <!-- <td pFrozenColumn class="grand-total-col"></td> -->
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandTotalApp | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandTotalArea | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandVerifiedApp | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandVerifiedAppArea | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPendingApp | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandIncompleteApp | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandIncompleteAppArea | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandRejectApp | number:'1.0-2'}}</td>
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandTotalEstimatedApp | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandTotalEstimatedArea | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPendingEstimateApp | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandVerifiedEstimateApp | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandVerifiedEstimateArea | number:'1.0-2'}}</td>
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandVerifiedEstApproved | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandVerifiedEstApprovedArea | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPendingEstApproved | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandRejectedEstVerified | number:'1.0-2'}}</td>
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandChallanGenerated | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandChallanDeposited | number:'1.0-2'}}</td>
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandBOQUploaded | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandBOQMIArea | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandBOQPending | number:'1.0-2'}}</td>
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandPVCompleted | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPV_MI_Area | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPV_Pending_with_JE | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPV_Pending_with_XEN | number:'1.0-2'}}</td>
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandApplicationswithDMIforSubsidy_Approval | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandApplications_Approved_at_Administartion | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPending_Subsidy_Calculation | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandSubsisdy_Approved_MI_Area | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandAssistanceAmount | number:'1.0-2'}}</td>
                <!-- <td class="grand-total-col"></td> -->
                <td class="grand-total-col">{{grandPending_Application_For_Payment_By_CAO | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPayment_Done_Application_By_CAO | number:'1.0-2'}}</td>
                <td class="grand-total-col">{{grandPayment_done_MI_Area | number:'1.0-2'}}</td>
            </tr>
            
        </ng-template>

    </p-table>
    </div>
    <!-- </p-card> -->
</p-panel>
